import Flex from '@Components/Bases/Flex';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import { Button, Dialog, Typography } from '@mui/material';

type ChangeYearModalProps = {
  opened: boolean;
  close: () => void;
  confirm: () => void;
};

const ChangeYearModal = ({ opened, close, confirm }: ChangeYearModalProps) => {
  return (
    <Dialog open={opened} onClose={close} maxWidth="xs">
      <Flex p={2} gap={2} borderBottom="1px solid rgba(0, 0, 0, 0.12)">
        <AssignmentLateOutlinedIcon
          style={{ fontSize: 32 }}
          color={'primary'}
        />
        <Flex flexDirection={'column'} gap={1}>
          <Typography fontWeight={800} fontSize={16}>
            ปรับระยะเวลาโครงการให้เป็นปัจจุบัน
          </Typography>
          <Typography style={{ whiteSpace: 'pre-line' }}>
            ท่านต้องการปรับระยะเวลาโครงการให้เป็นปัจจุบันหรือไม่
          </Typography>
        </Flex>
      </Flex>
      <Flex gap={2} p={1.5} justifyContent="flex-end">
        <Button variant="contained" color="inherit" onClick={close}>
          ยกเลิก
        </Button>
        <Button onClick={confirm}>ปรับระยะเวลาโครงการ</Button>
      </Flex>
    </Dialog>
  );
};

export default ChangeYearModal;
